const median = (a) => {
  if (!a.length) return null;
  const s = [...a].sort((x, y) => x - y), m = Math.floor(s.length / 2);
  return s.length % 2 ? s[m] : (s[m - 1] + s[m]) / 2;
};
const pct = (a, p) => {
  if (!a.length) return null;
  const s = [...a].sort((x, y) => x - y);
  return s[Math.min(s.length - 1, Math.floor(p * s.length))];
};

const blank = () => ({ days: 0, breaks: 0, breakTime: 0, lunchStarts: [], lunchDurs: [], over: 0, noBreak: 0, hours: new Array(24).fill(0) });

function add(acc, d, breakSec) {
  acc.days++;
  acc.breaks += d.gaps.length;
  d.gaps.forEach((g) => { acc.breakTime += g.dur; acc.hours[Math.floor(g.start / 3600) % 24]++; });
  if (!d.gaps.length) { acc.noBreak++; return; }
  const lunch = d.gaps.reduce((a, b) => (b.dur > a.dur ? b : a));
  acc.lunchStarts.push(lunch.start);
  acc.lunchDurs.push(lunch.dur);
  if (lunch.dur > breakSec) acc.over++;
}

function finish(key, a) {
  return {
    key, days: a.days, hours: a.hours,
    breaksPerDay: a.days ? a.breaks / a.days : 0,
    breakPerDay: a.days ? a.breakTime / a.days : 0,
    lunchStart: median(a.lunchStarts),
    lunchFrom: pct(a.lunchStarts, 0.25),
    lunchTo: pct(a.lunchStarts, 0.75),
    lunchAvg: a.lunchDurs.length ? a.lunchDurs.reduce((s, x) => s + x, 0) / a.lunchDurs.length : null,
    overPct: a.lunchDurs.length ? (a.over / a.lunchDurs.length) * 100 : null,
    over: a.over,
    noBreak: a.noBreak,
  };
}

export function breakReport(users, breakSec) {
  const months = {}, perUser = {};
  for (const u of users) for (const d of u.days) {
    const m = d.day.slice(0, 7);
    add(months[m] || (months[m] = blank()), d, breakSec);
    const pu = perUser[m] || (perUser[m] = {});
    add(pu[u.id] || (pu[u.id] = blank()), d, breakSec);
  }
  const keys = Object.keys(months).sort();
  return {
    months: keys.map((k) => finish(k, months[k])),
    pickers: Object.fromEntries(keys.map((k) => [k, Object.entries(perUser[k]).map(([id, a]) => ({ id, ...finish(k, a) })).sort((x, y) => y.breakPerDay - x.breakPerDay)])),
  };
}

export function weeklyOverruns(users, breakSec) {
  const byWeek = {};
  for (const u of users) for (const w of u.weeks) {
    const r = { id: u.id, days: w.days.length, over: 0, overSec: 0, longest: 0, longestDay: null, details: [] };
    for (const d of w.days) {
      if (!d.gaps.length) continue;
      const lunch = d.gaps.reduce((a, b) => (b.dur > a.dur ? b : a));
      if (lunch.dur > r.longest) { r.longest = lunch.dur; r.longestDay = d.day; }
      if (lunch.dur > breakSec) { r.over++; r.overSec += lunch.dur - breakSec; r.details.push({ day: d.day, start: lunch.start, dur: lunch.dur }); }
    }
    (byWeek[w.week] || (byWeek[w.week] = [])).push(r);
  }
  const weeks = Object.keys(byWeek).sort();
  weeks.forEach((k) => byWeek[k].sort((a, b) => b.over - a.over || b.overSec - a.overSec));
  return { weeks, byWeek };
}

export function repeatOffenders(weeks, byWeek, minDays, minStreak) {
  const per = {};
  weeks.forEach((w) => byWeek[w].forEach((r) => { (per[r.id] || (per[r.id] = {}))[w] = r; }));
  return Object.entries(per).map(([id, wk]) => {
    let cur = 0, best = 0, bestEnd = null, curStart = null, bestStart = null, flagged = 0, worked = 0;
    for (const w of weeks) {
      const r = wk[w];
      if (!r) continue;
      worked++;
      if (r.over >= minDays) {
        flagged++;
        if (!cur) curStart = w;
        cur++;
        if (cur > best) { best = cur; bestStart = curStart; bestEnd = w; }
      } else cur = 0;
    }
    return { id, current: cur, best, bestStart, bestEnd, flagged, worked, weeks: wk };
  }).filter((r) => r.best >= minStreak).sort((a, b) => b.current - a.current || b.best - a.best || b.flagged - a.flagged);
}
